import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { exigir } from '../nucleo/autorizacion/guardian.js';
import { rutaRaiz } from './raiz.js';

/**
 * Grupo de quien registra egresos, que son LOS CUATRO ROLES.
 *
 * Es un grupo nuevo, y hace falta porque ninguno de los tres que ya había sirve. El bloque de la
 * tarea 28 colgaba esta pantalla de `_contabilidad`, que exige `utilidad.ver` con nivel 3: el
 * operario, que es justamente quien registra los 80.000 de aseo de la caja menor del escenario de
 * la feature 13, **no puede entrar ahí**. Y `_operacion` exige `jornada.abrirCerrar`, que la
 * contadora no tiene, así que tampoco alcanza.
 *
 * La exigencia es `gastoCajaMenor.registrar`, que es la fila «Registrar gastos de caja menor» de la
 * matriz de la feature 2 y la única con sí en las cuatro columnas. No se inventa una acción nueva:
 * la matriz es contrato de la especificación, no una lista que se amplíe desde una pantalla.
 *
 * Qué medio puede usar cada rol no lo decide este guardián y no lo decide la pantalla: lo decide
 * `app.assert_puede_pagar_con`, derivándolo de `cuenta.nivel_visibilidad`.
 */
export const rutaEgresos = createRoute({
  getParentRoute: () => rutaRaiz,
  id: '_egresos',
  beforeLoad: ({ context }) => ({
    sesion: exigir(context, { accion: 'gastoCajaMenor.registrar' }),
  }),
  // El proveedor de consultas llega a pedido, igual que en los otros tres grupos.
  component: lazyRouteComponent(() => import('./consultas.js'), 'ProveedorConsultas'),
});
